import { render, staticRenderFns } from "./CultureEdit.vue?vue&type=template&id=6daf333d&scoped=true"
import script from "./CultureEdit.vue?vue&type=script&lang=js"
export * from "./CultureEdit.vue?vue&type=script&lang=js"
import style0 from "./CultureEdit.vue?vue&type=style&index=0&id=6daf333d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daf333d",
  null
  
)

export default component.exports